import React from "react";
import "../../styles/Licences/licencessign.css";
function Licenceassign(props) {
  const {
    handleAssignDetails,
    handleAssignUserDetails,
    handleSubmitAssignLicence,
    handleProductAssign,
    showAssignLicencePopUp,
    users,
    products,
    editassignlicense,
    assignlicence,
    handleSubmitEditAssignLicence,
  } = props;

  const renderUsers = () => {
    return users.map((user, index) => (
      <option key={index} value={user.id}>
        {user.Name}
      </option>
    ));
  };

  const renderProducts = () => {
    return products.map((product, index) => (
      <option key={index} value={product.ProductId}>
        {product.Product.Name}
      </option>
    ));
  };
  return (
    <div className="overlay">
      <div className="licenceassign_container">
        <div className="d-flex justify-content-between align-items-center">
          <span className="header">
            {editassignlicense ? "Edit license" : "Assign user"}
          </span>
          <button onClick={showAssignLicencePopUp} className="close">
            X
          </button>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          {!editassignlicense && (
            <div className="d-flex flex-column my-2 w-100">
              <span className="hint_text">User</span>
              <select
                // className="combobox_board  w-100 me-4"
                className="input_contianer"
                name=""
                id=""
                onChange={handleAssignUserDetails}
                defaultValue=""
              >
                <option value="">Select User</option>
                {renderUsers()}
              </select>
            </div>
          )}
          {!editassignlicense && (
            <div className="d-flex flex-column my-2 w-100">
              <span className="hint_text">Product</span>

              <select
                className="input_contianer"
                name=""
                id=""
                onChange={handleProductAssign}
                defaultValue=""
              >
                <option value="">Select Product</option>
                {renderProducts()}
              </select>
            </div>
          )}
          <div className="d-flex flex-column my-2 w-100">
            <span className="hint_text">Number of licence</span>
            <input
              className="input_contianer"
              type="text"
              name="NoOflicensesAssigned"
              placeholder="Enter number of licence"
              value={assignlicence.NoOflicensesAssigned}
              onChange={handleAssignDetails}
            />
          </div>
          <button
            onClick={
              editassignlicense
                ? handleSubmitEditAssignLicence
                : handleSubmitAssignLicence
            }
            className="btn"
          >
            {editassignlicense ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Licenceassign;
